module.exports = __webpack_public_path__ + "768c66e1232ef4305b3cf423ba7ce8d5.svg";